import React, { useEffect } from "react";
import "../../styles/vars.scss";
import "../../styles/main.scss";
import "../../styles/compo.scss";
import "../../styles/atoms.scss";
import SvgIcn from "../../data/IconCompo";

function Avatar({ imageUrl, size, className = "" }) {
  return (
    <div
      className={`avatar ${className}`}
      style={{ width: size, height: size }}
    >
      {imageUrl ? (
        <img src={imageUrl} alt="User Avatar" className="avatar-image" />
      ) : (
        <SvgIcn name="logo01" className="avatar-placeholder" />
      )}
    </div>
  );
}

export default Avatar;
